import Shake from '../../../plugins/shakeposition.js';
export default Shake;